import { useCallback } from 'react'
import { IconButton, styled } from '@mui/material'
import { resetPanel, resetSection } from 'weblite-router'
import { UserStatus } from '$common/user-status'
import { UserListItemSkeleton } from '$common/user-list-item'
import { pvMessageActionContent } from '$common/chat-list-item-new/hooks/pv-chat-list-item-hooks' // TODO: import from logic
import { RoomAppBarInfo } from '$common/room-app-bar/room-app-bar-info'
import { usePv } from '$logic/pv/react-hook'
import { getUserDisplayName, useUser } from '$logic/users'
import { useOpenedRoomMessageAction } from '$logic/opened-room/react-hook'
import { openUserProfile } from '$logic/router'
import { callService } from '$logic/call'
import { UserAvatar } from '$common/avatar'
import { useConnectionStatus } from '$comp/main/react-hook'
import { showErrorSnackbar } from '$comp/snackbars'
import { useBrowserIsOnline } from '$hooks/use-browser-connection'
import { t } from '$i18n'
import { ROOM_APP_BAR_AVATAR_SIZE } from '../conf'

const StyledUserStatus = styled(UserStatus)(({ theme }) => ({
  ...theme.typography.caption1,
}))

const StyledCallIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  margin-left: 4px;
`

export function PvAppBar({ roomId }: { roomId: string }) {
  const { entity: pv } = usePv(roomId)
  const { user } = useUser(pv?.to)
  const connectionStatus = useConnectionStatus()
  const isBrowserOnline = useBrowserIsOnline()

  const messageActions = useOpenedRoomMessageAction()
  const actionsContent = pvMessageActionContent(messageActions)

  const handleClick = useCallback(() => {
    if (user?.id) {
      // TODO[router]: Refactor
      resetSection('right')
      resetPanel('roomProfile')
      openUserProfile(user.id)
    }
  }, [user])

  const handleStartCall = useCallback(() => {
    if (connectionStatus === 'connected' && isBrowserOnline) {
      callService.startCall(roomId, 'PV', 'call')
    } else showErrorSnackbar(t('snackbar.call.noInternetConnection'))
  }, [connectionStatus, roomId, isBrowserOnline])

  if (!pv?.to || !user) return <UserListItemSkeleton /> // TODO: After mering 'skeleton integration' add small size to skeleton

  return (
    <RoomAppBarInfo
      onClick={handleClick}
      avatarElement={
        <UserAvatar
          userId={user.id}
          withStory
          size={ROOM_APP_BAR_AVATAR_SIZE}
        />
      }
      avatarSrc={''}
      avatarBackgroundColor={''}
      primaryText={getUserDisplayName(user)}
      secondaryText={actionsContent || <StyledUserStatus userId={pv.to} />}
      verified={user?.verified}
      callElement={
        // <StyledCallIconButton onClick={handleStartCall}>
        //   <CallIcon sx={{ color: 'neutral700' }} />
        // </StyledCallIconButton>
        null
      }
    />
  )
}
